import axiosInstance from "auth/FetchInterceptor";
import { GET_SURCHARGE_SLIP_BY_ORDER } from "constants/ApiConstant";

const SurchargeSlipService = {};

SurchargeSlipService.getByOrder = function (orderId) {
  return axiosInstance.get(`${GET_SURCHARGE_SLIP_BY_ORDER}/${orderId}`);
};

export default SurchargeSlipService;